import { useJointBillServiceProviderBillPlansQuery } from "@services/jointBillServiceProviderBillPlans/queries";
import { PlanId } from "@services/jointBillServiceProviderBillPlans/types";
import { LT_MAX_PLANS } from "@utils/plans/constants";
import { MainSelectionPlanCard } from "./components/MainSelectionPlanCard";
import { PlanCardSkeleton } from "./components/PlanCardSkeleton";
import { useMaxPlanPrice } from "./hooks/useMaxPlanPrice";

interface IPlansProps {
  jointBillServiceId?: number;
  onSuccess?: () => void;
}

export const PlansList: React.FC<IPlansProps> = (props) => {
  const { jointBillServiceId, onSuccess } = props;

  const { data } = useJointBillServiceProviderBillPlansQuery(
    jointBillServiceId ?? 0,
    !!jointBillServiceId,
  );

  const maxPlanPrice = useMaxPlanPrice(data);
  const isMaxPlanSelected = data?.some(
    (plan) => LT_MAX_PLANS.has(plan.jointBillServicePlanId) && plan.isSelected,
  );

  return (
    <div className="grid grid-cols-1 gap-6 px-4 md:px-0 lg:grid-cols-2 xl:grid-cols-3">
      {data && jointBillServiceId ? (
        data.map((plan) => (
          <MainSelectionPlanCard
            key={plan.jointBillServicePlanId}
            jointBillServiceId={jointBillServiceId}
            jointBillServicePlanId={plan.jointBillServicePlanId}
            isDisabledForJointBillService={!plan.isValidForJointBillService}
            price={
              plan.jointBillServicePlanId === PlanId.MAX
                ? maxPlanPrice
                : plan.price
            }
            discountedPrice={plan.discountedPrice}
            discountedMonths={plan.discountedMonths}
            discountExpirationDate={plan.discountExpirationDate}
            isSelected={
              plan.isSelected ||
              (plan.jointBillServicePlanId === PlanId.MAX && isMaxPlanSelected)
            }
            onSuccess={onSuccess}
            isPlanChangeAvailable={!!data.length}
          />
        ))
      ) : (
        <PlanCardSkeleton />
      )}
    </div>
  );
};
